<template>
  <div class="portal-session mt-4" :class="$vuetify.breakpoint.mdAndDown ? 'full-btn' : 'mx-2 d-flex align-center'">
    <v-btn
      color="primary"
      :loading="loading"
      rounded
      :block="$vuetify.breakpoint.mdAndDown"
      large
      @click="openCustomerPortal"
    >
      Gestionar mi Suscripción
    </v-btn>

    <v-snackbar
      v-model="showError"
      color="error"
      timeout="5000"
    >
      {{ error }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'PortalSession',
  
  data() {
    return {
      loading: false,
      error: null,
      showError: false
    };
  },

  methods: {
    async openCustomerPortal() {
      this.loading = true;
      this.error = null;

      try {
        const response = await this.axios({
          method: 'GET',
          url: '/billing/create-customer-portal-session',
        })

        if (response.data && response.data.session) {
          window.location.href = response.data.session.url;
        }
      } catch (error) {
        console.error('Error al crear sesión del portal:', error);
        this.error = 'Error al acceder al portal. Intenta nuevamente.';
        this.showError = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.portal-session {
  display: inline-block;
}

.portal-session.full-btn {
  display: block;
  width: 100%;
}
</style>